<template>
  <div style="background:#fff">
    <jz-header :currentPage="'hz'"></jz-header>
    <div class="hz-page">
      <div class="container main-body">
        <div class="nav-menu">
          <img src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-hand.png" class="hz-hand" />
          <div :class="[activeNav==0?'active-nav':'','nav-item']" @click="switchNav(0)">
            <div class="nav-title">异业合作/机构采购</div>
            <div class="arrow-block" v-show="activeNav==0">
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow.png"
                class="arrow-right"
              />
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow-left.png"
                class="arrow-left"
              />
            </div>
          </div>
          <div :class="[activeNav==1?'active-nav':'','nav-item']" @click="switchNav(1)">
            <div class="nav-title">家政从业人员报名</div>
            <div class="arrow-block" v-show="activeNav==1">
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow.png"
                class="arrow-right"
              />
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow-left.png"
                class="arrow-left"
              />
            </div>
          </div>
          <div :class="[activeNav==2?'active-nav':'','nav-item']" @click="switchNav(2)">
            <div class="nav-title">
              <div>加盟咨询</div>
              <div class="nav-tag">总部</div>
            </div>
            <div class="arrow-block" v-show="activeNav==2">
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow.png"
                class="arrow-right"
              />
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow-left.png"
                class="arrow-left"
              />
            </div>
          </div>
          <div :class="[activeNav==3?'active-nav':'','nav-item']" @click="switchNav(3)">
            <div class="nav-title">加盟咨询</div>
            <div class="arrow-block" v-show="activeNav==3">
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow.png"
                class="arrow-right"
              />
              <img
                src="https://jzmall.lifejingzhi.com/file/jz-gw/hz-icon-arrow-left.png"
                class="arrow-left"
              />
            </div>
          </div>
        </div>
        <div class="main-content" :style="'background-image:url('+bgUrl+')'">
          <div class="code-wrapper">
            <img :src="codeUrl" />
            <div>扫码联系</div>
          </div>
        </div>
      </div>
    </div>
    <jz-footer></jz-footer>
  </div>
</template>
<script>
import jzHeader from "@/components/common/Header";
import jzFooter from "@/components/common/Footer";
export default {
  data() {
    return {
      activeNav: 0,
      bgUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-yyhz-bg.png",
      codeUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-code-yehz.png",
      urlList: [
        {
          bgUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-yyhz-bg.png",
          codeUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-code-yehz.png"
        },
        {
          bgUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-jzcy-bg.png",
          codeUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-code-jzcy.png"
        },
        {
          bgUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-jmzx1-bg.png",
          codeUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-code-jmzx1.png"
        },
        {
          bgUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-jmzx2-bg.png",
          codeUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-code-jzcy.png"
          // codeUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/hz-code-jmzx2.png"
        }
      ]
    };
  },
  methods: {
    switchNav(id) {
      this.activeNav = id;
      this.bgUrl = this.urlList[id].bgUrl;
      this.codeUrl = this.urlList[id].codeUrl;
    }
  },
  components: {
    jzHeader,
    jzFooter
  }
};
</script>
<style  scoped>
.main-body {
  display: flex;
  height: 712px;
}
.nav-menu {
  width: 224px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  background: #F9FBFD;
}
.hz-hand {
  width: 72px;
  height: 54px;
  margin-bottom: 6px;
}
.nav-item {
  width: 164px;
  height: 45px;
  color: #333333;
  border-radius: 10px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
  position: relative;
}
.active-nav.nav-item {
  background: #00bdff;
  color: #fff;
}
.nav-title {
  display: flex;
  align-items: center;
  width: 164px;
  justify-content: center;
  cursor: pointer;
}
.nav-tag {
  padding: 2px 4px;
  line-height: 14px;
  background: #00bdff;
  border-radius: 3px;
  font-size: 10px;
  color: #fff;
  margin-left: 6px;
  box-sizing: border-box;
}
.active-nav.nav-item .nav-tag {
  border: 1px solid #fff;
  padding: 1px 4px;
}
.main-content {
  width: 756px;
  height: 712px;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/hz-yyhz-bg.png")
    no-repeat;
  background-size: 100% 100%;
  padding: 114px 0 0 46px;
  opacity: 1;
 transition: background 0.3s;
}
.code-wrapper {
  width: 200px;
  height: 255px;
  background: #1d202a;
  border-radius: 10px;
  border: 1px solid #000000;
  padding: 50px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;

}
.code-wrapper img {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}
.code-wrapper div {
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}
.arrow-block {
  height: 66px;
  display: flex;
  align-items: center;
  width: 51px;
  position: absolute;
  left: 191px;
  top: -10px;
  justify-content: space-between;
 opacity: 1;
 transition: opacity 1s ease-in-out;
}
.arrow-right {
  height: 66px;
  width: 21px;
}
.arrow-left {
  width: 10px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/cooperation.vue